import request from "@/service";

// 分页-(学员管理)
export function getPageStudent(params) {
  return request({
    url: `/study/classOffline/enroll/pageStudent`,
    method: "get",
    params,
  });
}

/* 线下班级：删除学员 */
export function deleteStudent(params) {
  return request({
    url: `/study/classOffline/enroll/deleteStudent`,
    method: "delete",
    data: params,
  });
}

/* 新增学员 */
export function saveStudent(params) {
  return request({
    url: `/study/classOffline/enroll/saveStudent`,
    method: "post",
    data: params,
  });
}

/* 报名成功的学员列表（用于学员管理回显） */
export function getStudentList(classId) {
  return request({
    url: `/study/class/enroll/studentList/${classId}`,
    method: "get",
  });
}

/* 导入学员 */
export function importEnroll(params) {
  return request({
    url: `/study/classOffline/enroll/importEnroll`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

/* 导出学员 */
export function exportEnroll(params) {
  return request({
    url: `/study/classOffline/enroll/exportEnroll`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data: params,
  });
}

// 批量下载 / 单个下载
export function batchDownload(params) {
  return request({
    url: `/study/classOffline/enroll/downloadBatch`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8",
    },
    data: params,
  });
}

// 修改班内职务
export function updatePost(params) {
  return request({
    url: `/study/classOffline/enroll/updatePost`,
    method: "post",
    data: params,
  });
}

export function deletePost(params) {
  return request({
    url: `/study/classOffline/enroll/deletePost`,
    method: "post",
    data: params,
  });
}

// 学员结业
export function graduation(params) {
  return request({
    url: `/study/classOffline/enroll/graduation`,
    method: "post",
    data: params,
  });
}

// 取消学员结业
export function cancelGraduation(params) {
  return request({
    url: `/study/classOffline/enroll/cancelGraduation`,
    method: "post",
    data: params,
  });
}

// 取消优秀学员
export function cancelExcellent(params) {
  return request({
    url: `/study/classOffline/enroll/cancelExcellent`,
    method: "post",
    data: params,
  });
}

// 设置优秀学员
export function setExcellent(params) {
  return request({
    url: `/study/classOffline/enroll/excellent`,
    method: "post",
    data: params,
  });
}

// 修改学制
export function updateTrainDays(data) {
  return request({
    url: `/study/classOffline/enroll/updateTrainDays`,
    method: "post",
    data,
  });
}

// 修改结业状态
export function updateGraduation(params) {
  return request({
    url: `/study/classOffline/enroll/updateGraduation`,
    method: "get",
    params,
  });
}

// 移动学员分页列表
export function pageMoveStudent(params) {
  return request({
    url: `/study/classOffline/enroll/pageMoveStudent`,
    method: "get",
    params,
  });
}

// 移动班级学员判断是否有班内职务
export function judgeMoveStudent(data) {
  return request({
    url: `/study/classOffline/enroll/judgeMoveStudent`,
    method: "post",
    data,
  });
}

// 获取关联班级
export function relationClass(params) {
  return request({
    url: `/study/classOffline/enroll/relationClass`,
    method: "get",
    params,
  });
}
// 移动班级学员
export function moveStudent(data) {
  return request({
    url: `/study/classOffline/enroll/moveStudent`,
    method: "post",
    data,
  });
}

// 编辑学员
export function updateStudent(data) {
  return request({
    url: `/study/classOffline/enroll/updateStudent`,
    method: "post",
    data,
  });
}

// 学员管理(学员名单)-调训班
export function tamePage(params) {
  return request({
    url: `/study/classOffline/enroll/tamePage`,
    method: "get",
    params,
  });
}

// 修改人选类型
export function updateSuperior(data) {
  return request({
    url: `/study/classOffline/enroll/updateSuperior`,
    method: "post",
    data,
  });
}

export function classOneClickCheck(data) {
  return request({
    url: `/study/classOffline/enroll/oneClickCheck`,
    method: "post",
    data,
    showLoading: false,
  });
}

export function classSwitchUnitPosition(data) {
  return request({
    url: `/study/classOffline/enroll/switchUnitPosition`,
    method: "post",
    data,
  });
}
